import React, { CSSProperties, useMemo } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps, useSelector } from 'react-redux';

import { RootState } from '../../../../../../init-store';
import { selectIsGlobalBarEnabled } from '../../../../features/config/selectors';
import { i18n } from '../../../../helpers/i18n';
import Button from '../../../button';
import I18N from '../../../i18n';
import Link from '../../../link';
import SvgImage from '../../../svg-image';
import { ImageName } from '../../../svg-image/images';
import css from './index.css';

const mapState = (state: RootState) => {
    const {
        ua: { OSFamily },
    } = state;

    return {
        OSFamily,
    };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

interface OSProps {
    title: string;
    iconName: ImageName;
    iconStyle?: CSSProperties;
}

const UnsupportedBrowserPage: React.FunctionComponent<Props> = ({ OSFamily }) => {
    const isGlobalBarEnabled = useSelector(selectIsGlobalBarEnabled);

    const OSHash: Record<string, OSProps> = {
        MacOS: {
            title: i18n('promo', 'mac-app'),
            iconName: 'apple',
            iconStyle: { marginTop: -2 },
        },
        Windows: {
            title: i18n('promo', 'win-app'),
            iconName: 'win',
        },
    };

    const desktopAppButtonData = OSHash[OSFamily];
    const isDesktopAppExists = !!desktopAppButtonData;

    const desktopAppIcon = useMemo(() => {
        if (!isDesktopAppExists) {
            return undefined;
        }

        return <SvgImage imageName={desktopAppButtonData.iconName} style={desktopAppButtonData.iconStyle} />;
    }, [desktopAppButtonData, isDesktopAppExists]);

    return (
        <div className={cn(css.Unsupported_container, { [css.containerWithoutHeaderAndFooter]: isGlobalBarEnabled })}>
            <span className={css.Unsupported_title}>{i18n('error-page', 'usupported-browser-title')}</span>
            <span className={css.Unsupported_subtitle}>
                <I18N
                    keyset="error-page"
                    loc={
                        isDesktopAppExists
                            ? 'unsupported-browser-subtitle2'
                            : 'unsupported-browser-subtitle2-no-desktop'
                    }
                >
                    <Link
                        data-ref="link-yabro"
                        className={css.Unsupported_link}
                        view="default"
                        href="https://browser.yandex.ru/"
                        target="_blank"
                    />
                </I18N>
            </span>
            {isDesktopAppExists && (
                <Button
                    view="brand"
                    elementType="a"
                    size="lg"
                    href="/download-desktop"
                    target="_blank"
                    iconLeft={desktopAppIcon}
                >
                    {desktopAppButtonData.title}
                </Button>
            )}
        </div>
    );
};

export default connector(UnsupportedBrowserPage);
